import { ApiService } from '@/services/api/api.service.ts'

export class ApiServiceFactory {
  createApiService(authFn: Function, headers: object, storageKey: string, baseUrl: string, timeout: number) {
    const tokenStorageKey = `${storageKey}_access_token`
    return new ApiService(authFn, headers, tokenStorageKey, baseUrl, timeout)
  }
}
